export const APP_NAME = 'PPAnalyser';
export const basePath = process.env.REACT_APP_BASE_PATH || '/';
